import { TableHeadProps } from "../tableTypes";
import {useEffect, useRef, useState} from "react";
import useView from "../../../hooks/useView";
import { Button, Input } from "antd";
import {FileExcelOutlined, FilterOutlined, TableOutlined} from "@ant-design/icons";
import "./table-head.css";
import useTableData from "../tableContext/useTableData";
import CsvDownloadButton from 'react-json-to-csv';
import {exportToCsv} from "../../../utils/exportToCsv";
import {formatDate, getFriendlyDate} from "../../../utils/friendlyDate";
import useUserContext from "../../../hooks/useUserContext";
import {getStyle} from "../getStyle";

const { Search } = Input;

const TableHead = ({ cols, title, showSearch, exportToExcel }: TableHeadProps) => {
    const { selectedDomain } = useUserContext();
    const { isFiltersPanelOpen, isColumnsPanelOpen, setIsFiltersPanelOpen, setIsColumnsPanelOpen, filters, sortingBy, sortingDirection } = useTableData();
    const tableHeadRef = useRef<HTMLDivElement | null>(null);
    const view = useView();
    const [shouldStick, setShouldStick] = useState(false);
    const [search, setSearch] = useState('');

    const onScroll = (event: Event) => {
        const rect = tableHeadRef.current?.getBoundingClientRect();
        const top = rect?.top || 0;
        const outOfBoundsLimit = view === 'platform' ? 0 : 72;
        setShouldStick(top <= outOfBoundsLimit);
    }

    const onSearch = () => {
        console.log("search: ", search);
    }

    const toggleFiltersPanel = () => {
        setIsFiltersPanelOpen(!isFiltersPanelOpen);
    }

    const toggleColumnsPanel = () => {
        setIsColumnsPanelOpen(!isColumnsPanelOpen);
    }

    useEffect(() => {
        document.addEventListener('scroll', onScroll);

        return () => {
            document.removeEventListener('scroll', onScroll);
        }
    });

    const onExcelClick = () => {
        exportToExcel();
    }

    return (
        <div className='table-head-container'>
            <div className={`table-head ${shouldStick ? 'stick' : ''}`}>
                <div className="table-bar">
                    <div className="left">
                        <Button shape="circle" icon={<FileExcelOutlined />} className='excel table-bar-button' onClick={onExcelClick} />
                        {/*<Button shape="circle" icon={<TableOutlined />} className={`columns table-bar-button ${isColumnsPanelOpen ? 'open' : ''}`} onClick={toggleColumnsPanel} />*/}
                    </div>
                    {title && <div className="floating-title">{title}</div>}
                    <div className="right">
                        {filters?.length ? <Button shape="circle" icon={<FilterOutlined />} className={`filter table-bar-button ${isFiltersPanelOpen ? 'open' : ''}`} onClick={toggleFiltersPanel} /> : null}
                        {showSearch && <Search placeholder="Search" value={search} onChange={(event) => setSearch(event.target.value)} onSearch={onSearch} style={{ width: 200 }} />}
                    </div>
                </div>
                <div className="titles">
                    {cols.map(col => {
                        return (
                            <div key={`table-head-col-${col.key}`} className="table-cell" style={getStyle(col)}>
                                {col.name}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div ref={tableHeadRef} className={`table-head placeholder ${shouldStick ? 'hold-position' : ''}`} />
        </div>
    );
}

export default TableHead;